// extracted by mini-css-extract-plugin
export default {"priceDisplay":"Pricing_priceDisplay__EXKOj"};